import type { PedidoEmAberto } from "@/store/self-service-kiosk-slice"

export interface ContaCalculada {
    subtotal: number
    desconto: number
    taxaServico: number
    total: number
    valorRecebido: number
    pendente: number
}

export function calcularConta(pedido: PedidoEmAberto | null): ContaCalculada {
    const subtotal = pedido?.subtotal ?? 0
    const desconto = pedido?.desconto ?? 0
    const taxaServico = pedido?.taxaServico ?? 0
    const total = pedido?.total ?? subtotal - desconto + taxaServico
    const valorRecebido = pedido?.valorRecebido ?? 0
    const pendente = Math.max(Math.round(total * 100) - Math.round(valorRecebido * 100), 0) / 100

    return { subtotal, desconto, taxaServico, total, valorRecebido, pendente }
}
